/*
Auditrail Cambio 6100 bsales 16/08/2022
-Se modifica la función login para que la respuesta solo sea el token
-Se agrega la función infousuario para obtener la información del estudiante.
*/
import axios from 'axios';
import { endpoint } from '../utils/utils';

export const getuserlogged = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).usuario;
  }
  return undefined;
};

// AV
export const getUserPidm = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).pidm;//
  }
  return undefined;
};

export const getusernamelogged = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).nombre;
  }
  return undefined;
};

export const getusercodeidlogged = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).codigo;
  }
  return undefined;
};

export const getuserperiodlogged = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).periodo;// "202210";//
  }
  return undefined;
};

export const getuserdescperiodlogged = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).desc_periodo;
  }
  return undefined;
};

export const getusercordinator = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).coordinador;
  }
  return undefined;
};

export const getusertoken = () => {
  if (localStorage.horun !== undefined) {
    return { headers: { Authorization: `Bearer ${JSON.parse(localStorage.horun).token}` } };
  }
  return undefined;
};

export const gettoken = () => {
  if (localStorage.horun !== undefined) {
    return JSON.parse(localStorage.horun).token;
  }
  return undefined;
};

export const islogged = () => localStorage.horun !== undefined;

export const login = async (usuario, contrasena, recaptchaValue) => { // Con ReCAPTCHA
  const user = {
    user: usuario,
    password: contrasena,
    token: recaptchaValue,
  };
    /* if(!axios.defaults.headers.common['Authorization']){
        const response = await axios.post(endpoint+'/user/login',  user )
        axios.defaults.headers.common['Authorization'] = 'Bearer '+response.data.token;
    } */
  try {
    const response = await axios.post(`${endpoint}/user/login`, user);
    localStorage.horun = JSON.stringify({ token: response.data.token });
    /* localStorage.horun = JSON.stringify({usuario,nombre:response.data.nombre,
codigo:response.data.codigo,periodo:response.data.periodo,desc_periodo:response.data.desc_periodo,
coordinador:response.data.coordinador,token:response.data.token}); */
    /* axios.defaults.headers.common['Authorization'] = 'Bearer '+response.data.token; */
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const login1 = async (usuario, contrasena) => { // Sin ReCAPTCHA
  const user = {
    user: usuario,
    password: contrasena,
  };
    /* if(!axios.defaults.headers.common['Authorization']){
const response = await axios.post(endpoint+'/user/login',  user )
axios.defaults.headers.common['Authorization'] = 'Bearer '+response.data.token;
} */
  try {
    const response = await axios.post(`${endpoint}/user/login`, user);
    localStorage.horun = JSON.stringify({ token: response.data.token });
    /* localStorage.horun = JSON.stringify({usuario,nombre:response.data.nombre,
codigo:response.data.codigo,periodo:response.data.periodo,desc_periodo:response.data.desc_periodo,
coordinador:response.data.coordinador,token:response.data.token}); */
    /* axios.defaults.headers.common['Authorization'] = 'Bearer '+response.data.token; */
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

// AV
export const infoPidm = async (usuario) => {
  try {
    const response = await axios.get(`${endpoint}/user/pidm/${usuario}`, getusertoken());
    const storage = gettoken();
    localStorage.horun = JSON.stringify({ token: storage, pidm: `${response.data.pidm}`, usuario: response.data.usuario });
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

// AV
export const setPidmByUser = async (usuario) => {
  try {
    const response = await axios.get(`${endpoint}/user/pidm/${usuario}`, getusertoken());
    const array = JSON.parse(localStorage.getItem('horun'));
    array.pidm = `${response.data.pidm}`;
    localStorage.setItem('horun', JSON.stringify(array));
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const infousuario = async (usuario) => {
  const user = {
    user: usuario,
  };

  try {
    const response = await axios.post(`${endpoint}/user/infousuario`, user, getusertoken());
    const storage = gettoken();

    // AV
    const json = JSON.parse(localStorage.horun);
    json.token = storage;
    json.nombre = response.data.nombre;
    json.codigo = response.data.codigo;
    json.periodo = response.data.periodo;
    json.desc_periodo = response.data.desc_periodo;
    json.coordinador = response.data.coordinador;

    localStorage.horun = JSON.stringify(json);

    /* localStorage.horun = JSON.stringify({token:storage, pidm:localStorage.pidm,
usuario:localStorage.usuario,nombre:response.data.nombre, codigo:response.data.codigo,
periodo:response.data.periodo,desc_periodo:response.data.desc_periodo,
coordinador:response.data.coordinador}); */
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const logout = () => {
  localStorage.clear();
};
